import { render, staticRenderFns } from "./ContenedorFormComponent.vue?vue&type=template&id=5d48bd1e&"
import script from "./ContenedorFormComponent.vue?vue&type=script&lang=js&"
export * from "./ContenedorFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports